<div class="relative">
  <div
    class="absolute inset-0 flex items-start justify-center pointer-events-none"
  >
    <div class="w-full max-w-[900px] mx-auto rounded-lg step-bg"></div>
  </div>

  <div class="step-card">
    <form
      [formGroup]="generaleForm"
      (ngSubmit)="onSubmitToLocalStorage()"
      class="step-form"
    >
      <div class="form-section">
        <div class="form-row">
          <div class="field">
            <app-select
              label="Programme"
              formControlName="programmeSelect"
              [options]="programmes"
              [loading]="loadingProgrammeSelect"
            ></app-select>
            @if (
              generaleForm.get("programmeSelect")?.touched &&
              generaleForm.get("programmeSelect")?.invalid
            ) {
              <small class="field-error"
                >Le champ 'Programme' est requis.</small
              >
            }
          </div>
          <div class="field">
            <app-select
              label="Type"
              formControlName="typeCodeSelect"
              [options]="types"
              [loading]="loadingTypes"
            ></app-select>
            @if (
              generaleForm.get("typeCodeSelect")?.touched &&
              generaleForm.get("typeCodeSelect")?.invalid
            ) {
              <small class="field-error">Le champ 'Type' est requis.</small>
            }
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <app-select
              [label]="getTypeLabel()"
              formControlName="typeInterventionSelect"
              [options]="resultatStructures"
              [loading]="loadingStructures"
            ></app-select>
            @if (
              generaleForm.get("typeInterventionSelect")?.touched &&
              generaleForm.get("typeInterventionSelect")?.invalid
            ) {
              <small class="field-error">
                Veuillez sélectionner {{ getTypeLabel() }}.
              </small>
            }
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <app-input
              type="text"
              formControlName="activities"
              label="Activités"
            ></app-input>
            @if (
              generaleForm.get("activities")?.touched &&
              generaleForm.get("activities")?.invalid
            ) {
              <small class="field-error"
                >Le champ 'Activités' est requis.</small
              >
            }
          </div>
          <div class="field">
            <app-input
              label="Description"
              type="text"
              formControlName="description"
            ></app-input>
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <app-input
              type="date"
              formControlName="dateDebut"
              label="Date de début"
            ></app-input>
            @if (
              generaleForm.get("dateDebut")?.touched &&
              generaleForm.get("dateDebut")?.invalid
            ) {
              <small class="field-error">La date de début est requise.</small>
            }
          </div>
          <div class="field">
            <app-input
              label="Date de fin"
              type="date"
              formControlName="dateFin"
            ></app-input>
            @if (
              generaleForm.get("dateFin")?.touched &&
              generaleForm.get("dateFin")?.invalid
            ) {
              <small class="field-error">La date de fin est requise.</small>
            }
          </div>
        </div>
      </div>

      <!--
        ⚠️  IMPORTANT — bouton natif obligatoire pour déclencher (ngSubmit).
        app-ui-button génère son propre <button> dans un shadow DOM partiel ;
        Angular ne relie pas ce bouton au <form> parent.
        On stylise ici avec les classes du design system.
      -->
      <div class="actions">
        <button
          type="button"
          class="btn btn-danger btn-md"
          [routerLink]="['/activities/activity']"
        >
          <span class="material-icons btn-icon btn-icon--left">close</span>
          Annuler
        </button>
        <button type="submit" class="btn btn-primary btn-md">
          Suivant
          <span class="material-icons btn-icon btn-icon--right"
            >arrow_right_alt</span
          >
        </button>
      </div>
    </form>
  </div>
</div>
